/* eslint-disable camelcase */
import { getResizedImageUrl } from '@lib/image';

export type { RichTextBlock as IPrismicText } from 'prismic-reactjs';

export interface IPrismicUrl {
  url: string;
  link_type: string;
  target?: string;
}

export interface IPrismicInternalLink {
  id: string;
  slug: string;
  uid: string;
  link_type: string;
  isBroken: boolean;
}

export interface IPrismicDimensions {
  height: number;
  width: number;
}

export interface IPrismicMetaKeyword {
  meta_keyword: string;
}

export interface IPrismicImage {
  alt?: string;
  copyright?: string;
  url: string;
  mobile_view?: IPrismicImage;
  tablet_view?: IPrismicImage;
  desktop_view?: IPrismicImage;
  large_desktop_view?: IPrismicImage;
  dimensions: IPrismicDimensions;
}

/**
 * Creates a new prismic image from the given URL and dimension information.
 * Useful for when we want to use a component that can work with both Prismic
 * fed data and alternate data sources.
 */
export function createPrismicImage({
  url,
  altText,
  dimensions,
  mobileDimensions,
  tabletDimensions,
  desktopDimensions
}: {
  url: string;
  altText?: string;
  dimensions: IPrismicDimensions;
  mobileDimensions?: IPrismicDimensions;
  tabletDimensions?: IPrismicDimensions;
  desktopDimensions?: IPrismicDimensions;
}) {
  const resizeOpts = {
    url,
    quality: 90
  };

  const image: IPrismicImage = {
    url: getResizedImageUrl({
      ...resizeOpts,
      ...dimensions
    }),
    alt: altText,
    dimensions
  };

  if (mobileDimensions) {
    image.mobile_view = {
      url: getResizedImageUrl({
        ...resizeOpts,
        ...mobileDimensions
      }),
      dimensions: mobileDimensions
    };
  }

  if (tabletDimensions) {
    image.tablet_view = {
      url: getResizedImageUrl({
        ...resizeOpts,
        ...tabletDimensions
      }),
      dimensions: tabletDimensions
    };
  }

  if (desktopDimensions) {
    image.desktop_view = {
      url: getResizedImageUrl({
        ...resizeOpts,
        ...desktopDimensions
      }),
      dimensions: desktopDimensions
    };
  }

  return image;
}

export interface IPrismicDoc {
  id: string;
  uid: string;
  type: string;
}
